import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer as RTC } from 'react-toastify';
import { Store } from 'redux';
import { GlobalStyles, ReactDayPickerStyles, ToastStyles, ToastTransition } from 'components';
import { AnalyticsProvider } from 'contexts/analytics';
import { FeatureFlagsProvider } from 'contexts/featureFlags';
import { FullStoryProvider } from 'contexts/fullstory';
import { SessionProvider } from 'contexts/session';
import { theme } from 'design';
import { AppRoutes } from 'routes/AppRoutes';
import { IStore } from 'store/types';
import './design/fonts/fonts.css';

interface IAppProps {
  store: Store<IStore>;
}

const App: React.FC<IAppProps> = ({ store }: IAppProps) => (
  <>
    <GlobalStyles />
    <ToastStyles />
    <ReactDayPickerStyles />
    <Provider store={store}>
      <FeatureFlagsProvider>
        <AnalyticsProvider>
          <FullStoryProvider>
            <SessionProvider>
              <RTC position="top-center" transition={ToastTransition} draggable={false} closeOnClick closeButton={false} autoClose={theme.toast.timing} hideProgressBar />
              <AppRoutes />
            </SessionProvider>
          </FullStoryProvider>
        </AnalyticsProvider>
      </FeatureFlagsProvider>
    </Provider>
  </>
);

export default App;
